export default __webpack_public_path__ + "media/images/features/ambassador/mv_pc-cd6660a2b191845fdeb50adaad8cf88d.jpg";